import { render, staticRenderFns } from "./RatingForm.vue?vue&type=template&id=25c8fd4f&scoped=true"
import script from "./RatingForm.vue?vue&type=script&lang=js"
export * from "./RatingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8fd4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c8fd4f')) {
      api.createRecord('25c8fd4f', component.options)
    } else {
      api.reload('25c8fd4f', component.options)
    }
    module.hot.accept("./RatingForm.vue?vue&type=template&id=25c8fd4f&scoped=true", function () {
      api.rerender('25c8fd4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/parameters/RatingForm.vue"
export default component.exports